import { getGlobalProperties, advertiseDetails } from "@/assets/js/utils.js";
import { ref } from "vue";
export default {
  props: ["type"],

  setup(props) {
    const {
      advertiseApi
    } = getGlobalProperties().$api;
    let bannerList = ref([]);
    let bannerList1 = ref([]);
    console.log(props);

    const getBanner = () => {
      console.log(props);
      advertiseApi({
        type: props.type || 1
      }, "get").then(res => {
        if (res.code === 0) {
          bannerList.value = res.data.rows.filter(a => a.ad_type === 1);
          bannerList1.value = res.data.rows.filter(a => a.ad_type === 2);
        }
      });
    };

    getBanner();

    const toDetails = item => {
      if (item.link) {
        // countApi({ url: item.link }, "get");
        // window.open(item.link);
        advertiseDetails(item.link);
      }
    };

    return {
      props,
      bannerList,
      bannerList1,
      toDetails
    };
  }

};